import { FinancingFlowApi } from '~/services/financing-flow-api/financing-flow.types';

const INSTALLATION_DONE_STATUSES = ['approved', 'completed'];

export const TITULARITY_TRANSFER_BLOCKED_MESSAGES = {
  installationNotDone: 'Não é possível trocar a titularidade: a etapa de instalação precisa estar concluída/aprovada.',
  missingProjectId: 'Não é possível trocar a titularidade: financiamento sem project_id.',
} as const;

/**
 * Retorna o motivo que impede a troca de titularidade, ou null quando ela é permitida.
 * Só permite com project_id e com a etapa de instalação concluída/aprovada.
 */
export function getTitularityTransferBlockReason(financing: FinancingFlowApi.FinancingV2): null | string {
  if (!financing.project_id?.trim()) return TITULARITY_TRANSFER_BLOCKED_MESSAGES.missingProjectId;

  const installation = financing.section_statuses?.installation;
  const installationStatus = installation?.status?.toLowerCase().trim() ?? '';
  const isInstallationDone = !!installation?.completed_at || INSTALLATION_DONE_STATUSES.includes(installationStatus);

  if (financing.step !== 'installation' || !isInstallationDone) {
    return TITULARITY_TRANSFER_BLOCKED_MESSAGES.installationNotDone;
  }

  return null;
}
